import styled from "styled-components";

export const CardContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  gap: 16px;
  width: 100%;
  border-radius: 12px;
  
  ${props => props.active ? `
    background: #EFE9FE;
    border: 1px solid #9B5AF8;
  ` : `
    background: #FFFFFF;
    box-shadow: 0px 0px 5.9px rgba(0, 0, 0, 0.25);
  `}
`;

export const PlanHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const PlanIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  border-radius: 16px;
  
  background: ${props => {
    switch (props.type) {
      case "premium":
        return "linear-gradient(213.84deg, #A15FFF 20.14%, #7F4CC7 103.22%)";
      case "essential":
        return "#325AE9";
      case "prosuite":
        return "linear-gradient(180deg, #FBCF21 -6.22%, #FFBE07 27.16%, #FF9C00 83.73%, #ED8900 103.48%)";
      case "free":
        return "#98A2B3";
      default:
        return "#9B5AF8";
    }
  }};
`;

export const PlanIcon = styled.span`
  font-family: 'DM Sans', sans-serif;
  color: white;
  font-weight: bold;
  font-size: 14px;
`;

export const PlanTitle = styled.span`
  font-family: 'DM Sans', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: ${props => props.active ? '#565556' : '#123051'};
`;

export const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 12px;
`;

export const OriginalPrice = styled.span`
  font-family: 'DM Sans', sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  color: #9A999A;
  text-decoration: line-through;
`;

export const DiscountedRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
`;

export const Price = styled.span`
  font-family: 'DM Sans', sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 20px;
  color: #123051;
`;

export const PriceInterval = styled.span`
  font-family: 'DM Sans', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: #9A999A;
`;

export const ValidityPeriod = styled.div`
  font-family: 'DM Sans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #123051;
  margin-top: 4px;
`;

export const AnnualBillingText = styled.div`
  font-family: 'DM Sans', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: #9A999A;
  margin-top: 4px;
`; 